export default {
	register: {
        SMS: "/bss/app/noauth/GetVerificationCodeBySMS",                // 获取短信验证码接口
        registerUser: "/bss/dsds/noauth/RegisterDSDSUser",                   // 注册用户接口
        resetPwd_SMS: "/bss/app/noauth/ResetPasswordBySMS",             // 短信重置密码接口
        MAIL: "/bss/app/noauth/SendResetPasswordMail",                  // 发送重置密码邮件接口
        resetPwd_MAIL: "/bss/app/noauth/ResetPasswordByMail",           // 邮件重置密码接口
        active_MAIL: "/bss/app/noauth/SendActivationMail",              // 发送激活邮件接口
        activeUser: "/bss/app/noauth/ActiveUser",                       // 激活账号接口
        checkUser: "/bss/app/noauth/CheckUserCode",                     // 校验用户名称合法性
        checkSMS: "/bss/dsds/noauth/VerifyVerificationCodeFromDSDS",    // 校验短信验证码接口
        queryEnterpriseConfigList:"/bss/app/noauth/queryEnterpriseConfigList",// 获取分站配置
    },
    interfaces: {
        getCountryInfo: "/glocalme/interfaces/getCountryInfo",               // 获取国家/地区列表接口
        
    },
}


// WEBPACK FOOTER //
// ./src/libs/api.js